import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const getGuestProductBrands = async () => {
  try {
    const result = await instance({
      url: Endpoints.GET_GUEST_PRODUCT_BRANDS,
      method: 'GET',
    });

    return result?.data;
  } catch (error) {
    console.error('Error fetching guest product brands:', error);
    return null;
  }
};
